import { createInMemoryAtom } from '@exodus/atoms';
const createExchangeableAssetsAtom = () => createInMemoryAtom({ defaultValue: { fromAssetIds: [], toAssetIds: [] } });
export default createExchangeableAssetsAtom;
